module.exports = __webpack_public_path__ + "m1.png";